console.log("MODE SELECTOR CARREGADO");

document.addEventListener("DOMContentLoaded", function () {


    /* ==========================================================
       ELEMENTOS PRINCIPAIS
    ========================================================== */

    const wheel = document.querySelector(".mode-wheel");
    const modeTitle = document.querySelector(".mode-section-title");

    const modes = document.querySelectorAll(".mode-point");
    const knob = document.querySelector(".mode-knob");
    const tooltip = document.querySelector(".mode-tooltip");


    /* ==========================================================
       ANIMAÇÃO DE ENTRADA DA RODA
    ========================================================== */

    if(wheel){

        setTimeout(() => {

            wheel.classList.add("show");

        }, 300);

    }


    /* ==========================================================
       ANIMAÇÃO DE ENTRADA DO TÍTULO
    ========================================================== */

    if(modeTitle){

        const titleObserver = new IntersectionObserver((entries) => {

            entries.forEach(entry => {

                if(entry.isIntersecting){

                    modeTitle.classList.add("show");

                    titleObserver.unobserve(modeTitle);

                }

            });

        }, {
            threshold:0.25
        });


        titleObserver.observe(modeTitle);

    }


    /* ==========================================================
       VERIFICA ELEMENTOS DA PARTE INTERATIVA
    ========================================================== */

    if(!modes.length || !knob || !tooltip){

        console.warn(
            "MODE SELECTOR: algum elemento interativo não foi encontrado."
        );

        return;

    }


    let currentRotation = 0;


    /* ==========================================================
       GIRAR KNOB
    ========================================================== */

    function rotateKnob(rotation){

        let targetRotation = Number(rotation);

        let difference =
            targetRotation - currentRotation;


        /* mantém o giro pelo caminho mais curto */

        if(difference > 180){

            targetRotation -= 360;

        }


        if(difference < -180){

            targetRotation += 360;

        }


        currentRotation = targetRotation;


        knob.style.transform =
            `rotate(${currentRotation}deg)`;

    }


    /* ==========================================================
       ATIVAR MODO
    ========================================================== */

    function activateMode(mode){


        /* ======================================================
           REMOVE ATIVO DOS OUTROS
        ====================================================== */

        modes.forEach(item => {

            item.classList.remove("active");

        });


        /* ======================================================
           ATIVA MODO ATUAL
        ====================================================== */

        mode.classList.add("active");


        /* ======================================================
           GIRA KNOB
        ====================================================== */

        rotateKnob(mode.dataset.rotation);


        /* ======================================================
           TEXTO
        ====================================================== */

        const title =
            tooltip.querySelector("h3");

        const description =
            tooltip.querySelector("p");


        if(title){

            title.textContent =
                mode.dataset.title || "";

        }


        if(description){

            description.textContent =
                mode.dataset.description || "";

        }


        /* ======================================================
           VIDEO + THUMB
        ====================================================== */

        const video =
            tooltip.querySelector(".mode-video");

        const source =
            tooltip.querySelector(".mode-video source");


        if(video && source){


            /* pausa qualquer vídeo que estava tocando */

            video.pause();


            /* volta o vídeo para o começo */

            try{

                video.currentTime = 0;

            }catch(error){

                /* evita erro caso o vídeo ainda não tenha carregado */

            }


            /* ==============================================
               THUMB / POSTER DO MODO
            ============================================== */

            const posterUrl =
                mode.dataset.poster || "";


            if(posterUrl){

                video.setAttribute(
                    "poster",
                    posterUrl
                );

            }

            else{

                video.removeAttribute("poster");

            }


            /* ==============================================
               VIDEO DO MODO
            ============================================== */

            const videoUrl =
                mode.dataset.video || "";


            if(videoUrl){

                console.log(
                    "VIDEO:",
                    videoUrl
                );

                console.log(
                    "POSTER:",
                    posterUrl
                );


                source.src =
                    videoUrl;


                /*
                load() recarrega o novo vídeo
                e faz o poster correspondente aparecer
                */

                video.load();

            }

            else{

                source.removeAttribute("src");

                video.load();

            }

        }


        /* ======================================================
           RECORTE DO BOX
        ====================================================== */

        tooltip.classList.remove(
            "cut-1",
            "cut-2",
            "cut-3",
            "cut-4",
            "cut-5",
            "cut-6",
            "cut-7",
            "cut-8",
            "cut-9"
        );


        const modeClass =
            Array.from(mode.classList)
                .find(
                    className =>
                        /^mode-\d+$/.test(className)
                );


        if(modeClass){

            const modeNumber =
                modeClass.replace(
                    "mode-",
                    ""
                );


            tooltip.classList.add(
                "cut-" + modeNumber
            );

        }


        /* ======================================================
           POSIÇÃO DESKTOP
        ====================================================== */

        if(window.innerWidth > 768){

            const point =
                mode.getBoundingClientRect();


            const wheelRect =
                wheel.getBoundingClientRect();


            tooltip.style.left =
                (
                    point.left -
                    wheelRect.left +
                    50
                ) + "px";


            tooltip.style.top =
                (
                    point.top -
                    wheelRect.top -
                    40
                ) + "px";

        }

        else{

            tooltip.style.left = "";

            tooltip.style.top = "";

        }


        /* ======================================================
           MOSTRA TOOLTIP
        ====================================================== */

        tooltip.classList.add("active");

    }


    /* ==========================================================
       EVENTOS
    ========================================================== */

    modes.forEach(mode => {


        /* ======================================================
           DESKTOP - HOVER
        ====================================================== */

        mode.addEventListener(
            "mouseenter",
            () => {

                activateMode(mode);

            }
        );


        /* ======================================================
           MOBILE - TOQUE
        ====================================================== */

        mode.addEventListener(
            "click",
            () => {

                activateMode(mode);

            }
        );


    });


    /* ==========================================================
       ABRE O MODO 1 AUTOMATICAMENTE
    ========================================================== */

    const firstMode =
        document.querySelector(".mode-1");


    if(firstMode){

        activateMode(firstMode);

    }


});